import React from "react";
import { NavLink, Link } from "react-router-dom";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <footer className="footer-root">
                <div className="footer-inner">
                    <div className="footer-grid">
                        <div>
                            <p className="footer-slogan">
                                Ваш гид в мире рыбалки. Находите лучшие места, узнавайте новое, делитесь опытом.
                            </p>
                            <Link to="/spots/new" className="footer-add-spot-button">
                                Добавить точку
                            </Link>
                        </div>

                        <div>
                            <h4 className="footer-heading">Навигация</h4>
                            <nav className="footer-nav">
                                {[
                                    ["/",      "Главная"],
                                    ["/map",   "Карта"],
                                    ["/fishes","Рыбы"],
                                    ["/blog",  "Блог"],
                                ].map(([to, label]) => (
                                    <NavLink key={to} to={to} className="footer-link">{label}</NavLink>
                                ))}
                            </nav>
                        </div>

                        <div>
                            <h4 className="footer-heading">Инструменты</h4>
                            <nav className="footer-nav">
                                <NavLink to="/tools/fish-detection" className="footer-link">Определить рыбу</NavLink>
                                <NavLink to="/tools/sonar-upload" className="footer-link">Загрузить эхолот</NavLink>
                                <NavLink to="/tools" className="footer-link">Все инструменты</NavLink>
                            </nav>
                        </div>

                        <div>
                            <h4 className="footer-heading">Полезное</h4>
                            <nav className="footer-nav">
                                <NavLink to="/profile" className="footer-link">Профиль</NavLink>
                                <NavLink to="/profile/my-spots" className="footer-link">Мои точки</NavLink>
                                <NavLink to="/profile/suggestions" className="footer-link">Предложения</NavLink>
                            </nav>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <span className="footer-bottom-copyright">
                            © {currentYear} FishMap. Все права защищены.
                        </span>
                        <div className="footer-bottom-policy">
                            <Link to="/privacy-policy" className="footer-link font-size-14">Конфиденциальность</Link>
                            <Link to="/about" className="footer-link font-size-14">О проекте</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
